import AddInterpretationButton from './AddInterpretationButton'

export default AddInterpretationButton



// WEBPACK FOOTER //
// ./src/legacy/components/AddInterpretationButton/index.js